import React, { useEffect, useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import Modal from "../../Atoms/Modal";
import { useAnnouncementStore } from "../../../Store/Announcement";
import {
  AnnouncementTemplateType,
  AnnouncementUserInteraction
} from "../../../Contracts/Announcement";
import AnnouncementTemplate1 from "./AnnouncementTemplate1";

const AnnouncementModal: React.FC = () => {
  const { announcement, getAnnouncement, registerInteraction } =
    useAnnouncementStore();
  const { getAccessTokenSilently } = useAuth0();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      getAnnouncement(getAccessTokenSilently);
    }, 7000);
    return () => clearTimeout(timer);
  }, [getAnnouncement, getAccessTokenSilently]);

  useEffect(() => {
    if (announcement) {
      setIsOpen(true);
    }
  }, [announcement]);

  const dismiss = () => {
    setIsOpen(false);
    if (!announcement) return;
    registerInteraction(
      getAccessTokenSilently,
      announcement.id,
      AnnouncementUserInteraction.DISMISSED
    );
  };

  const remindLater = () => {
    setIsOpen(false);
    if (!announcement) return;
    registerInteraction(
      getAccessTokenSilently,
      announcement.id,
      AnnouncementUserInteraction.REMIND_LATER
    );
  };

  const view = () => {
    setIsOpen(false);
    if (!announcement) return;
    registerInteraction(
      getAccessTokenSilently,
      announcement.id,
      AnnouncementUserInteraction.VIEWED
    );
  };

  const modalSizeMap = {
    sm: "small",
    md: "medium",
    lg: "large"
  } as const;

  return (
    <Modal
      isOpen={isOpen}
      onClose={dismiss}
      footer={null}
      size={modalSizeMap[announcement?.modal_size ?? "sm"]}
    >
      {announcement?.template_type === AnnouncementTemplateType.Template1 && (
        <AnnouncementTemplate1
          announcement={announcement}
          remindLater={remindLater}
          viewAnnouncement={view}
        />
      )}
    </Modal>
  );
};

export default withAuthenticationRequired(AnnouncementModal);
